export default __webpack_public_path__ + "static/media/JPstreet-night.a6869378.jpeg";